// extracted by mini-css-extract-plugin
module.exports = {"new-nav":"navigation_new-nav__j52Dl","navMenu":"navigation_navMenu__PswLa","mp-menu":"navigation_mp-menu__107yz"};